import React, { createContext, useCallback, useContext, useState } from 'react';
import { IProductBase } from '../models/products';
import { maskDateTime } from '../utils/formatters/handleMask';

export interface IProductContextState extends IProductBase {
  formattedCreatedAt: string;
}

interface IProductContextData {
  product?: IProductContextState;
  handleProduct: (product?: IProductBase) => void;
}

const ProductContext = createContext<IProductContextData>(
  {} as IProductContextData,
);

const ProductProvider: React.FC = ({ children }) => {
  const [product, setProduct] = useState<IProductContextState>();

  const handleProduct = useCallback((productData?: IProductBase) => {
    if (productData) {
      setProduct({
        ...productData,
        formattedCreatedAt: maskDateTime(productData.createdAt),
      });
    } else {
      setProduct(undefined);
    }
  }, []);

  return (
    <ProductContext.Provider
      value={{
        product,
        handleProduct,
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};

const useProduct = (): IProductContextData => useContext(ProductContext);

export { ProductProvider, useProduct };
